export enum DeliveryType {
    POST_OFFICE = 'Balík na poštu',
}
